import { useEffect, useState } from 'react';
import { useListEc2ConfigsQuery, useListUsersQuery } from '../lib/api';

export interface KontingentProps {
  username: string;
}

const calculateTimeLeft = (terminateTimestamp?: number) => {
  let timeLeft = { hours: 0, minutes: 0, seconds: 0};

  if(terminateTimestamp) {
    let difference = Math.floor(((terminateTimestamp * 1000) - Date.now()) / 1000);

    // console.log(difference);

    if (difference > 0) {
      timeLeft = {
        hours: Math.floor((difference / (60 * 60)) % 24),
        minutes: Math.floor((difference / 60) % 60),
        seconds: Math.floor((difference) % 60)
      };
    }
  }
  
  return timeLeft;
}

export function Kontingent({username}:KontingentProps) {

  const listEc2ConfigsQuery = useListEc2ConfigsQuery(
    {
    filter: { userId: { eq: username } },
  }
  , {
    refetchOnWindowFocus: false,
    queryKey: ['listEc2Configs'],
  });

  const terminateTimestamp = listEc2ConfigsQuery.data?.listEc2Configs?.items[0]?.terminateTimestamp;

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(terminateTimestamp));

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(terminateTimestamp));
    }, 1000);
    // Clear timeout if the component is unmounted
    return () => clearTimeout(timer);
  });

  const listUsersQuery = useListUsersQuery(
    {
    filter: { userId: { eq: username } },
  }
  , {
    refetchOnWindowFocus: false,
    queryKey: ['listUsers'],
  });
  // const kontingentCurrent = listUsersQuery.data?.listUsers?.items[0]?.kontingentCurrent;

  if (listUsersQuery.isLoading || listEc2ConfigsQuery.isLoading) return <div>Loading...</div>;
    
  return (
    <div>
      <h3>Username: {username}</h3>
      <h3>1:30h von 8h verbraucht</h3>
      <h3>Labor aktiv: {timeLeft.hours}:{timeLeft.minutes}:{timeLeft.seconds}</h3>
    </div>
  );
}